import { render, staticRenderFns } from "./Purpose.vue?vue&type=template&id=ef1a20ca&scoped=true"
import script from "./Purpose.vue?vue&type=script&lang=js"
export * from "./Purpose.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef1a20ca",
  null
  
)

export default component.exports